import { Avatar, Box, Button, Icon, IconButton, Menu, Portal } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"
import { Link } from "@tanstack/react-router"
import { FaRebel, FaUserAstronaut } from "react-icons/fa"
import { FiLogOut, FiMoon, FiSettings, FiSun, FiUser } from "react-icons/fi"
import type { UserPreview } from "../../client"

import useAuth from "../../hooks/useAuth"
import { useColorMode } from "../UI/color-mode"
import { UserMenuProps } from "../../api/users"


const UserMenu = ({ onClose } : UserMenuProps) => {
  const { logout } = useAuth()
  const queryClient = useQueryClient()
  const currentUser = queryClient.getQueryData<UserPreview>(["currentUser"])

  const handleLogout = async () => {
    logout()
  }

  const { colorMode, toggleColorMode } = useColorMode()

  return (
    <>
      {/* Mobile */}
      <Box display={{ base: "flex", md: "none" }} justifyContent="space-between" mb={6}>
        <Button
          asChild
          aria-label="Dark Mode"
          bg="main"
          borderRadius={8}
          onClick={toggleColorMode}
          value={colorMode}
          px={8}
          mr={4}
        >
          <IconButton>
            {colorMode === "dark" ? (
              <FiSun color="white" fontSize="20px" />
            ) : (
              <FiMoon color="white" fontSize="20px" />
            )}
          </IconButton>
        </Button>

        <Button
          asChild
          aria-label="Settings"
          bg="main"
          borderRadius={8}
          px={8}
          onClick={() => {onClose ? onClose() : null}}
        >
          <Link to="/usersettings">
              {currentUser?.email === "informatik@wochen-zeitung.ch" ? (
                <FaRebel color="white" fontSize="23px" />
              ) : (
                  <FiSettings color="white" fontSize="18px" />
              )}
          </Link>
        </Button>
      </Box>

      {/* Desktop */}
      <Box display={{ base: "none", md: "block" }}>
        <Button
          asChild
          aria-label="Dark Mode"
          bg="main"
          border="1px solid white"
          borderRadius="full"
          data-testid="dark_mode"
          onClick={toggleColorMode}
          right={2}
        >
          <IconButton>
            {colorMode === "dark" ? (
              <FiSun color="white" fontSize="20px" />
            ) : (
              <FiMoon color="white" fontSize="20px" />
            )}
          </IconButton>
        </Button>

        <Menu.Root>
          <Menu.Trigger
            asChild
            aria-label="Options"
            bg="main"
            border="1px solid white"
            borderRadius="full"
            data-testid="user_menu"
          >
            <IconButton>
              {currentUser?.email === "informatik@wochen-zeitung.ch" ? (
                <FaRebel color="white" fontSize="23px" />
              ) : (
                <Avatar.Root bgColor="transparent">
                    <Avatar.Fallback>
                      <Icon as={FaUserAstronaut} color="white" w="inherit" h="inherit" />
                    </Avatar.Fallback>
                    <Avatar.Image src={currentUser?.fk_media_profile_pic?.path.replace(/-(LG)\./, "-SM.")} />
                  </Avatar.Root>
              )}
            </IconButton>
          </Menu.Trigger>

          <Portal>
            <Menu.Positioner w={"3xs"}>
              <Menu.Content>
                <Menu.Item value="Einstellungen" asChild cursor="pointer">
                  <Link to="/usersettings">
                    <FiUser fontSize="18px" />
                    Einstellungen
                  </Link>
                </Menu.Item>
                <Menu.Separator />
                <Menu.Item
                  onClick={handleLogout}
                  color="danger"
                  fontWeight="bold"
                  value="Abmelden"
                  fontSize="15px"
                  cursor="pointer"
                >
                  <FiLogOut fontSize="18px" />
                  Abmelden
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>
      </Box>
    </>
  )
}

export default UserMenu
